import React, { Component } from "react";
import { Form, FormGroup, Label, Input } from "reactstrap";
import Select from "react-select";
import { deepCopyObject, showAxiosError } from "../../util/Helpers";
import { API_BASE_URL } from "../../constants";
import { request } from "../../util/APIUtils";
import Alert from "react-s-alert";
import LoadingIndicator from "../../common/LoadingIndicator";

class MeetingForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            meetingData: {
                toplantiKonusu: "",
                toplantiTarihi: "",
                toplantiSaati: "",
                toplantiBitisSaati: "",
                members: null,
            },
            isMeetingModalOpen: false,
            selectedKatilimcilar: [],
            loading: false,
            error: null,
            errors: {},
            page: 0,
            size: 10,
            meet: null,
            mode: "review",
            isLoading: false,
        };
    }

    componentDidMount() {
        if (this.state.mode === "review") {
            this.setState({ fieldsDisabled: true });
        }
        if (this.props.selectedMeeting) {
            let selectedMeeting = deepCopyObject(this.props.selectedMeeting);
            this.setState({
                meetingData: selectedMeeting,
            });
        }
        this.listMember(this.state.page, this.state.size);
        this.validateComponent = this.validateComponent.bind(this);
    }

    listMember(page, size) {
        let self = this;
        let params = {
            url: API_BASE_URL + "/uye/uyeler?page=" + page + "&size=" + size,
            method: "get",
        };

        self.setState({ loading: true });
        request(params)
            .then(function (response) {
                let katilimci = response.data;
                const members = katilimci.map((katilimci) => ({
                    value: katilimci.id,
                    label: katilimci.ad + " " + katilimci.soyad,
                }));
                self.setState({
                    meetingData: {
                        ...self.state.meetingData,
                        members: members,
                    },
                    loading: false,
                });
            })
            .catch(function (error) {
                self.setState({
                    loading: false,
                    error: "Katılımcıları almak başarısız oldu.",
                });
            });
    }

    handleKatilimciChange = (selectedOptions) => {
        this.setState({ selectedKatilimcilar: selectedOptions });
    };

    handleInputChange = (name, value) => {
        let meetingData = { ...this.state.meetingData };


        if (name === 'toplantiTarihi' || name === 'toplantiSaati' || name === 'toplantiBitisSaati') {

            meetingData[name] = value;
        } else {

            meetingData[name] = value.toString();
        }

        this.setState({ meetingData });
    };


    validateComponent = () => {
        const { toplantiKonusu, toplantiTarihi, toplantiSaati } =
            this.state.meetingData;
        const isValid = {
            valid: true,
            errors: {},

        };

        if (!toplantiKonusu) {
            isValid.valid = false;
            isValid.errors["toplantiKonusu"] = "Toplantı konusu boş olamaz.";
        }

        if (!toplantiTarihi) {
            isValid.valid = false;
            isValid.errors["toplantiTarihi"] = "Toplantı tarihi boş olamaz.";
        }

        if (!toplantiSaati) {
            isValid.valid = false;
            isValid.errors["toplantiSaati"] = "Toplantı saati boş olamaz.";
        }
       // if (!toplantiBitisSaati) {
         //   isValid.valid = false;
           // isValid.errors["toplantiBitisSaati"] = "Toplantı bitiş saati boş olamaz.";
        //}

        this.setState({ error: isValid.errors });
        return isValid;
    };

    saveMeeting = () => {
        let self = this;
        let params;
        let data;
        let message;
        let token = localStorage.getItem("accessToken");
        let validity = this.validateComponent();
        if (validity.valid) {
            self.setState({ isLoading: true });
            let meeting = deepCopyObject(this.state.meetingData);
            meeting.members = this.state.selectedKatilimcilar.map(
                (member) => member.value
            );
            data = meeting;
            if (!meeting.id) {
                message = "Toplantı Başarıyla Kaydedildi.";
                params = {
                    url: API_BASE_URL + "/createMeet",
                    data: data,
                    method: "post",
                    headers: {
                        Authorization: "Bearer " + token,
                        "Content-Type": "application/json",
                    },
                };
            } else {
                message = "Toplantı Başarıyla Güncellendi.";
                params = {
                    url: API_BASE_URL + `/updateMeeting/${meeting.id}`,
                    data: data,
                    method: "put",
                    headers: {
                        Authorization: "Bearer " + token,
                        "Content-Type": "application/json",
                    },
                };
            }

            request(params)
                .then(() => {
                    Alert.success(message, {
                        position: "top-right",
                        effect: "stackslide",
                        timeout: 5000,
                    });
                    self.setState({ loading: false });
                    self.props.handleSearch(self.props.searchQuery, true);
                    self.props.cancelProcess();
                })
                .catch(function (error) {
                    self.setState({ loading: false });
                    showAxiosError(error);
                });
        } else {
            Alert.error("Hatalı veya eksik alanlar var!", {
                position: "top-right",
                effect: "stackslide",
                timeout: 5000,
            });
        }
    };

    openMeetingModal = () => {
        this.setState({ isMeetingModalOpen: true });
    };
    errors;

    render() {
        const { cancelProcess, mode } = this.props;
        const {
            toplantiKonusu,
            toplantiTarihi,
            toplantiSaati,
            toplantiBitisSaati,
            members,
        } = this.state.meetingData;

        return (
            <div className="memberForm--main-container">
                {this.state.isLoading && (
                    <div className="loader">
                        <LoadingIndicator />
                    </div>
                )}

                <div className="memberForm-container">
                    <Form>
                        <div className="FormRenk col-sm-12">
                            <span className="form-title">Toplantı Bilgileri</span>
                            <div className="row">
                                <Label className="col-sm-3">
                                    Toplantı Konusu <span className="text-danger">*</span>
                                </Label>
                                <div className="col-sm-8 form-group">
                                    <input
                                        className="form-control uppercase"
                                        type="text"
                                        name="toplantiKonusu"
                                        id="toplantiKonusu"
                                        value={toplantiKonusu}
                                        maxLength="50"
                                        onBlur={this.validateField}
                                        ref="toplantiKonusu"
                                        onChange={(e) =>
                                            this.handleInputChange("toplantiKonusu", e.target.value)
                                        }
                                    />
                                    {this.errors && this.errors.toplantiKonusu && (
                                        <div className="text-danger">{this.errors.toplantiKonusu}</div>

                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">
                                    Toplantı Tarihi <span className="text-danger">*</span>
                                </Label>
                                <div className="col-sm-8 form-group">
                                    <input
                                        className="form-control uppercase"
                                        type="date"
                                        name="toplantiTarihi"
                                        id="toplantiTarihi"
                                        value={toplantiTarihi}
                                        onBlur={this.validateField}
                                        ref="toplantiTarihi"
                                        onChange={(e) =>
                                            this.handleInputChange("toplantiTarihi", e.target.value)
                                        }
                                    />
                                    {this.errors && this.errors.toplantiTarihi && (
                                        <div className="text-danger">{this.errors.toplantiTarihi}</div>
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3" style={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
                                    Toplantı Başlangıç Saati<span className="text-danger" style={{ marginLeft: '4px' }}>*</span>
                                </Label>
                                <div className="col-sm-8 form-group">
                                    <input
                                        className="form-control uppercase"
                                        type="time"
                                        name="toplantiSaati"
                                        id="toplantiSaati"
                                        value={toplantiSaati}
                                        onBlur={this.validateField}
                                        ref="toplantiSaati"
                                        onChange={(e) =>
                                            this.handleInputChange("toplantiSaati", e.target.value)
                                        }
                                    />
                                    {this.errors && this.errors.toplantiSaati && (
                                        <div className="text-danger">{this.errors.toplantiSaati}</div>
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Toplantı Bitiş Saati: </Label>
                                <div className="col-sm-8 form-group">
                                    <input
                                        className="form-control uppercase"
                                        type="time"
                                        name="toplantiBitisSaati"
                                        id="toplantiBitisSaati"
                                        value={toplantiBitisSaati}
                                        onBlur={this.validateField}
                                        ref="toplantiBitisSaati"
                                        onChange={(e) =>
                                            this.handleInputChange("toplantiBitisSaati",e.target.value)
                                        }
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Katılımcılar: </Label>
                                <div className="col-sm-8 form-group">
                                    <Select
                                        className="basic-single"
                                        classNamePrefix="select"
                                        placeholder="Lütfen Katılımcı Seçiniz"
                                        isClearable={false}
                                        isSearchable={false}
                                        isMulti
                                        value={this.state.selectedKatilimcilar}
                                        onChange={this.handleKatilimciChange}
                                        options={members}
                                        name="members"
                                        id="members"
                                        ref="members"
                                        style={{ flex: 1 }}
                                    />
                                </div>
                            </div>
                        </div>
                    </Form>
                    <div className="save-button-container mb-5">
                        <button
                            onClick={this.saveMeeting}
                            className="member-save-button"
                            disabled={this.state.isLoading}
                        >
                            {mode === "create" ? "TAMAM" : "KAYDET"}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default MeetingForm;



// WEBPACK FOOTER //
// ./src/page/odaList/MeetingForm.js